// 3D Model constants for SSOP/MSOP packages
export const ssopPinMarkerSize = 0.0003; // Smaller than grid array marker (0.0004)
export const ssopPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 500;
export const ssopPinMarkerOffsetZ = 0.000001;
export const ssopPinMarkerSegments = 32;
//# sourceMappingURL=ssopConstants.js.map